import './App.css';
import { Route, Routes, Outlet, useNavigate, Navigate } from "react-router-dom"
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { ProSidebarProvider } from 'react-pro-sidebar';
import { ToastContainer, toast } from "react-toastify";
import "tippy.js/dist/tippy.css";

//components
import Navigation from "./components/Navbar"
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';


// Imports
import Import from './Import/Import';

//Setting
import EditSetting from './Layouts/setting/EditSetting';
import EditExtrafileds from './Layouts/setting/EditExtraFiled';
import Setting from './Layouts/setting/Setting';
import PartyRoleSettings from "./Layouts/setting/PartyRoleSettings";
import TermsConditions from "./Layouts/setting/TermsConditions";

// Authentication
import Login from './Layouts/authentication/Sign-in/login';
import AutoLogout from './Layouts/authentication/Logout/AutoLogout';
import AddTimeoutSettingService from './services/settings/AddTimeSettingServices';
import Chatboatui from './Layouts/authentication/Sign-in/chatui';

//sign up
import NewSignup from './Layouts/authentication/Sign-up/newSubscription/newSign-up';
import SignUpSubscription from './Layouts/authentication/Sign-up/sig-up';
import ConfirmSub from './Layouts/authentication/Sign-up/confirmsub';
import SubscriptionSuccess from './Layouts/authentication/Sign-up/SubscriptionSuccess';
import Signup from './Layouts/authentication/Delaypayment/signup';
import SignUp from './Layouts/authentication/Sign-up/Sign-Up';
import Register from './Layouts/authentication/Sign-up/signUp';
import SingupConfirm from './Layouts/authentication/Sign-up/singup-confirm';
import Otp from './Layouts/authentication/Sign-in/OtpVerifications';
import ConfirmEle from './Layouts/authentication/Sign-up/confirmEle';

// Password
import Changepassword from './Layouts/authentication/Changepassword/changepassword';
import Forgotpassword from './Layouts/authentication/Forgotpassword/forgotpassword';


// Dashboard
import Dashboard from './Layouts/dashboard/index';
import TestTable from './Layouts/dashboard/test';
import PendingContracts from './Layouts/dashboard/componets/PendingContracts';
import InvoicesDue from './Layouts/dashboard/componets/InvoicesDue';
import Contractsdashboard from './Layouts/dashboard/componets/Contractsdashboard';
import UnappliedPayments from './Layouts/dashboard/componets/UnappliedPayments';
import Checkmt from './Layouts/dashboard/checkmt';

// Party
import Party from './Layouts/parties/index';
import PartyAdd from './Layouts/parties/components/party/Party-Add';
import PartyEdit from './Layouts/parties/components/party/Party-Edit'
import PartyDetails from './Layouts/parties/components/party/Party-Details'
import EditParty from './Layouts/parties/components/party/EditParty';

//Party Address
import PartyAddAddress from './Layouts/parties/components/address/Party-Add-Address'
import EditAddress from './Layouts/parties/components/address/editAddress'

//Party contact
import Partycontact from './Layouts/parties/components/contact/Party-contact'
import ContactEdit from './Layouts/parties/components/contact/ContactEdit'
import AddnewPartyIndex from './Layouts/parties/components/party/AddnewPartyIndex';

//Party Notifications
import AddNotification from './Layouts/parties/components/notifications/AddNotification'
import EditNotification from './Layouts/parties/components/notifications/EditNotification'
import ManageNotification from './Layouts/parties/components/notifications/ManageNotification'
import ViewNotification from './Layouts/parties/components/notifications/ViewNotification'

// Contract
import Contract from './Layouts/contracts/index'
import AddContract from './Layouts/contracts/AddContract';
import CreateContract from './Layouts/contracts/components/Lease/CreateContract'
import ContractEdit from './Layouts/contracts/components/Lease/Contract-Edit'
import ContractView from './Layouts/contracts/components/Contract-View'

import CreateContractLoan from './Layouts/contracts/components/Loan/CreateLoanScreen';
import EditLoanScreen from './Layouts/contracts/components/Loan/EditLoanScreen';
import AsstesForLoan from './Layouts/contracts/components/Loan/AssetsForLoan';

import CreateRentalContract from './Layouts/contracts/components/Rental/CreateRentalContract';
import ContractRentalEdit from './Layouts/contracts/components/Rental/EditRentalContract';

//Quotes
import QuoteAdd from './Layouts/contracts/components/Quotes/QuoteAdd';
import QuoteView from './Layouts/contracts/components/Quotes/QuoteView';

//Amort
import ViewAmortSchedules from './Layouts/contracts/components/AmortSchedulDetail/ViewAmortSchedules'

// Payment Schedule
import AddPaymentSchedules from './Layouts/contracts/components/add-paymentSchedules'
import EditPaymentSchedules from './Layouts/contracts/components/editPaymentSchedule';

// Asset
import AddAssets from './Layouts/contracts/components/Asset/add-assets'
import EditAssets from './Layouts/contracts/components/Asset/editAsset';
import ViewAssets from './Layouts/contracts/components/Asset/viewAssets';
import Assetsretrunscrren from './Layouts/contracts/components/assetsretrunscrren';

//Tax Rate
import TaxRates from './Layouts/Accounting/Tax Rate/Taxrate';
import AddTaxRate from './Layouts/Accounting/Tax Rate/AddTaxRate';
import EditTaxRate from './Layouts/Accounting/Tax Rate/EditTaxRate';
import TaxRateView from './Layouts/Accounting/Tax Rate/ViewTaxRate';


// ItemMaster
import ItemMaster from './Layouts/ItemMaster';
import Itemmasteradd from './Layouts/ItemMaster/componets/Itemmasteradd';
import ItemmasterEdit from './Layouts/ItemMaster/componets/ItemmasterEdit';
import ItemmasterView from './Layouts/ItemMaster/componets/ItemmasterView';
import CreateRateCardHeader from './Layouts/ItemMaster/componets/RateCardHeader/addratecardheader';
import ViewRateCard from './Layouts/ItemMaster/componets/RateCardview';
import EditRateCardHeader from './Layouts/ItemMaster/componets/RateCardHeader/editratecardheader';
import RatecardTable from './Layouts/ItemMaster/componets/RateCardTable';

//Billing
import Billing from './Layouts/billing';
import EditInvoices from './Layouts/billing/componets/Edit-Invoices';
import CreateInvoices from './Layouts/billing/componets/CreateInvoices';
import CreateInvoices1 from './Layouts/billing/componets/temp1';
import ViewInvoices from './Layouts/billing/componets/ViewInvoices';


//Report
import Reports from './Layouts/reports';
import ContractReport from './Layouts/reports/componets/ContractReport';
import InvoiceReport from './Layouts/reports/componets/InvoiceReport';
import ReciptReport from './Layouts/reports/componets/ReciptReport';
import AllExpenseReport from './Layouts/reports/componets/expensesReport';
import ManualAccountingReport from './Layouts/reports/componets/manualaccountingReport';

//Receipt
import ViewRecipts from './Layouts/receipts/index';
import CreateRecipts from './Layouts/receipts/componets/CreateRecipts';
import EditRecipts from './Layouts/receipts/componets/EditRecipt';
import ShowRecipts from './Layouts/receipts/componets/ViewRecipts';

//processing
import ViewProcessing from './Layouts/processing';
import GenrateBills from './Layouts/processing/componets/GenrateBills';
import GenrateNotification from './Layouts/processing/componets/GenralNotification';

//User
import ManageUser from './Layouts/User';
import AddUser from './Layouts/User/componets/AddUser';
import EditUser from './Layouts/User/componets/EditUser';
import UserVerification from './Layouts/User/componets/UserVerification';
import UserPermissionsTable from './Layouts/User/componets/Updatepermssion';
import EditCustomerUser from './Layouts/User/componets/EditCustomeruser';

//Company
import Profile from './Layouts/compnay/profile';
import EditProfile from './Layouts/compnay/componets/EditProfile';
import Additionalsetting from './Layouts/compnay/additionalsetting';
import GetCompanyInfoService from './services/company/getCompanyInfoService';

//Accounting
import AccountingPeriods from './Layouts/Accounting/AccountingPeriod';
import Accounts from './Layouts/Accounting/Accounts';
import AccountingSetup from './Layouts/Accounting/AccountingSetup';
import TrialBalance from './Layouts/Accounting/TrialBalance';
import LeagalEntities from './Layouts/Accounting/Company';
import TransactionTypes from './Layouts/Accounting/TransactionTypes';
import Transaction from './Layouts/Accounting/Transaction';
import AddAccountingSetup from './Layouts/Accounting/AddAccountingSetup';

//Payment
import PaymentHandleScreen from './Layouts/Payment/PaymentScreen/Index';
import PaymentScreen from './Layouts/Payment';
import PaymentSuccess from './Layouts/Payment/paymentsuccess';
import StripeConnectButton from './Layouts/Payment/stripeconnect/stripeonboarding';
import ConfirmEleExisting from './Layouts/Payment/stripeconnect/existingconfirmele';
import NewPaymentScreen from './Layouts/Payment/newAddUser';
import PaymentConfirmExistingEle from './Layouts/Payment/CustomPayment/PaymentConfirmEle';


//supportTicket
import SupportTicket from './Supportticket/Index';


import Searchshow from './Layouts/Searchshow';
import Protecte from './PrivateRoute'
import Testchatbot from './Layouts/testchatbot';
import Helper from './Helper';
import Impersonate from './impersonate';
import FinalUnifiedScheduler from './Layouts/schedule';
import Categories from './Layouts/categories';
import Createcategoriies from './Layouts/categories/Createcategories';
import Editcategory from './Layouts/categories/Editcategory';
import Categoryview from './Layouts/categories/Category-view';
// import Document from './Layouts/UploadDocument/document';
import Doc from './Layouts/UploadDocument/doc';
import ContractLeaseForm from './Layouts/contracts/components/Lease/createLease';
import CreateLoan from './Layouts/contracts/components/Loan/createLoan';
import CreateRental from './Layouts/contracts/components/Rental/createRental';

// import ACH provider
import AchProviders from './Layouts/achprovider';
import AddAchProvider from './Layouts/achprovider/CreateACH';
import EditAchProvider from './Layouts/achprovider/EditACH';
import ViewAchProvider from './Layouts/achprovider/ViewACH';

// import ACH Accounts
import AddAchAccounts from './Layouts/parties/components/achAccount/achAdd';
import EditAchAccounts from './Layouts/parties/components/achAccount/achEdit';
import AchIndex from './Layouts/parties/components/achAccount/index';
import ViewAchAccount from './Layouts/parties/components/achAccount/achView';

// import Tickets
import CompanyTickets from './Layouts/tickiting/company';
// import InternalTickets from './Layouts/tickiting/internalTickets';
import { TicketProvider } from './Layouts/tickiting/components/TicketProvider';
import EditCompanyTicket from './Layouts/tickiting/components/edit_companyTicket';
import UserTickets from './Layouts/tickiting/user';
import ViewUserTicket from './Layouts/tickiting/components/edit_userTicket';
import ACHFileView from './Layouts/compnay/componets/ACHFile';


//import Json
import JsonToDbImport from './Layouts/Json/json';

//import Email Formator
import EmailFormatter from './Layouts/EmailFormator/EmailEditor'
import EmailTemplates from './Layouts/EmailFormator/EmailTemplets';
import EmailTemplatesView from './Layouts/EmailFormator/EmailTemplateView'; 

// user guides
import Documentation from './Layouts/guide/documantation';
import ApiDocumentation from './Layouts/guide/ApiDocumentation';
// Expenses
//Expenses
import Expenses from './Layouts/expenses/index';
import AddExpense from './Layouts/expenses/AddExpense';
import EditExpense from './Layouts/expenses/EditExpense';

// expenses Categories
import ExpenseCategories from './Layouts/expenses/expensesCategories/expensesCat';
import ViewExpense from './Layouts/expenses/ViewExpense';
import AddExpenseCategory from './Layouts/expenses/expensesCategories/addExpenseCategory';
import EditExpenseCategory from './Layouts/expenses/expensesCategories/EditExpenseCategory';

// Report Templates
import BalanceSheet from './Layouts/reports/componets/BalanceSheet';
import IncomeStatement from './Layouts/reports/componets/IncomeStatement';
import ContractsIncome from './Layouts/reports/componets/ContractsIncome';
import ContractBalances from './Layouts/reports/componets/ContractBalances';
import DetailBalanceSheet from './Layouts/reports/componets/DetailBalanceSheet';
import DetailIncomeStatement from './Layouts/reports/componets/DetailIncomeStatement';


// Manual Accounting
import ManualAccountingIndex from './Layouts/ManualAccounting/Index';
import AddManualAccount from './Layouts/ManualAccounting/AddManualAccounting';
import EditManualAccount from './Layouts/ManualAccounting/EditManualAccounting';
import ViewManualAccounting from './Layouts/ManualAccounting/ViewManualAccounting';

import Transactions from './Layouts/Transactions/Transactions';




// Tile Layout Settings  
import TileSettings from './Layouts/TileSettings';

// profile
import CompanyProfile from './Layouts/compnay/CompanyProfile';
import SubCompanies from './Layouts/compnay/SubCompanies';
import LinesOfBusiness from './Layouts/compnay/LinesOfBusiness';

//Accounts
import AddAccount from "././Layouts/Accounting/Accounts/AddAccount";
import EditAccount from "././Layouts/Accounting/Accounts/EditAccount";

// Approvals
import Approvals from './Layouts/Approvals/Index';
import ViewRequest from './Layouts/Approvals/ViewRequest';
import AddRequest from "./Layouts/Approvals/AddRequest";
import AllApprovals from './Layouts/Approvals/AllApproval';

  
import CreateContractAgent from './components/contract agent/create-contract-agent';
import ContractImportPage from './contractimport/ContractImportPage';

// outlet
window.locale = 'en-US'
window.currency = 'USD'

const SidebarLayout = ({ menuShowHide, setMenuShowHide, customerPermission, profileImage, customData, notesLength, setRtl, rtl }) => (
  <>
    <TicketProvider>
      <ProSidebarProvider>

        <Sidebar setMenuShowHide={setMenuShowHide} menuShowHide={menuShowHide} customerPermission={customerPermission} rtl={rtl} setRtl={setRtl} />
        <div className='main-content border-radius-lg' >
          <Navigation setMenuShowHide={setMenuShowHide} menuShowHide={menuShowHide} customerPermission={customerPermission} profileImage={profileImage} customData={customData} notesLength={notesLength} setRtl={setRtl} rtl={rtl} />
          <Outlet />
        </div>
      </ProSidebarProvider>
      <Footer customerPermission={customerPermission} />
      {/* <Chatboatui/> */}
    </TicketProvider>
  </>
)

function App() {
  const navigate = useNavigate()
  const [menuShowHide, setMenuShowHide] = useState(false)
  const [checkAuth, setCheckAuth] = useState(false)
  const token = JSON.parse(localStorage.getItem('user'))
  const [profileImage, setProfileImage] = useState(false)
  const [subscriptionstaus, setSubscriptionStatus] = useState("")
  const [cancelDate, setCancelDate] = useState("")

  const customerPermission = localStorage.getItem('customer')

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [date, setDateRegister] = useState('');

  const user = JSON.parse(localStorage.getItem("user"));
  const last_login_string = localStorage.getItem("last_login")
  const last_login = last_login_string === 'null' ? null : new Date(last_login_string);
  const [customData, setCustomData] = useState({
    object_id: null,
    object_name: null
  })
  const [rtl, setRtl] = useState(false);

  const [notesLength, setNotesLength] = useState(null)

  useEffect(() => {
    if (user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, [user]);

  const dateDifferenceInDays = (date1, date2) => {
    const diffInMilliseconds = Math.abs(date1 - date2);
    return Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));
  };

  const handelDefaultcompany = () => {
    if (isLoggedIn === true) {
      if (customerPermission !== 'Customer') {
        GetCompanyInfoService.getCompanyInfo().then((response) => {
          let dateof = response.data.date_registered
          let dadad = new Date(dateof).toISOString().split('T')[0]
          setDateRegister(dadad);
        });
      }
    }
  };
  useEffect(() => {
    handelDefaultcompany()
  }, [date])

  // const handelTickiting = () =>{
  //   const user = JSON.parse(localStorage.getItem('user'));
  //   if (user?.customer) {
  //     navigate('/dashboard');
  //   } else {
  //     navigate('/company');
  //   }
  // };



  // const handlePaymentData = () => {
  //   axios.get(API + 'accounting/paymentget/', { headers: authHeader() })
  //     .then((res) => {
  //       setData(res.data.payment_details.map((val) => val))
  //       if (res.data.success === 1) {
  //         // if (res.data.payment_details !==""){
  //         const payment_id = res.data.payment_details.map((val) => val.payment_id)

  //         axios.post(API + 'accounting/stripesubscriptionretrive/', { 'paymentId': payment_id[0] }, { headers: authHeader() }).then(
  //           (response) => {
  //             console.log('response', response)
  //             const timestamp = response.data.response.cancel_at
  //             if (timestamp !==null){

  //               const datee = new Date(timestamp * 1000); // Convert seconds to milliseconds
  //               const formattedDate = datee.toDateString();
  //               setCancelDate(Helper.DatePicker(formattedDate))
  //               setSubscriptionStatus(response.data.response.status)
  //             }
  //             else{
  //               setCancelDate('')
  //             }
  //           }
  //         )
  //       }
  //       // }
  //     }
  //     )
  // }

  // useEffect(() => {
  //   if (isLoggedIn === true) {

  //     handlePaymentData()
  //   }
  // }, [isLoggedIn])

  useEffect(() => {
    // if (date !== '') {

    //   const user = JSON.parse(localStorage.getItem('user'));

    //   if (user) {
    //     const decodedToken = jwtDecode(user.access);

    //     // Assuming the registration date is available in the token (replace 'registrationDate' with the actual field)
    //     const registrationDate = new Date(date);

    //     const currentDate = new Date();
    //     const daysSinceRegistration = dateDifferenceInDays(currentDate, registrationDate);
    //     if (daysSinceRegistration > 15) {
    //       navigate('/payment');
    //     }
    //   }
    // }
    if (isLoggedIn === true) {

      // if(subscriptionstaus !== ""){
      //   if (subscriptionstaus ==="canceled"){
      //     navigate('/payment')
      //   }
      // }
      const subcriptionDate = new Date()
      const currentDate = Helper.DatePicker(subcriptionDate)
      if (cancelDate !== '') {
        if (cancelDate <= currentDate) {
          navigate('/payment')
        }
      }
      else {
        console.log("error")
      }
    }
  }, [navigate, subscriptionstaus]);


  const JWTverify = () => {
    try {
      const decodedToken = jwtDecode(token.access)
      if (decodedToken.exp * 1000 < Date.now()) {
        localStorage.clear();
        setCheckAuth(true)
        navigate('/login')
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const inpersonate_login = localStorage.getItem('inpersonate_login')
  const impersonate_User = localStorage.getItem('username')
  const inpersonate_CompanyName = localStorage.getItem('companyName')

  useEffect(() => {
    if (inpersonate_login === '1') {
      toast.success(
      <div style={{ lineHeight: '1.5' }}>
      <p style={{ fontSize: '16px', marginBottom: '10px' }}>Logging you in...</p>
      <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0 }}>
        Company: <span style={{ fontWeight: 'normal' }}>{inpersonate_CompanyName ? inpersonate_CompanyName : ""}</span>
      </p>
      <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0 }}>
        User: <span style={{ fontWeight: 'normal' }}>{impersonate_User ? impersonate_User : ""}</span>
      </p>
    </div>
      , {
        position: "top-right",
        autoClose: false,
        hideProgressBar: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        closeOnClick:false,
        // closeButton:false,
        style: { marginTop: '50px' },
      });
    }
  }, [inpersonate_login])


  useEffect(() => {
    JWTverify()
  }, [checkAuth])
  // const [timeout, setTimeout] = useState(null)

  const [inputValue, setInputValue] = useState(null)
  useEffect(() => {
    const fetchTimeoutSetting = async () => {
      try {
        const res = await AddTimeoutSettingService.getTimeoutSetting();
        const timeoutMinutes = parseInt(res.data.timeout) * 60 * 1000;;
        if (!isNaN(timeoutMinutes)) {
          setInputValue(timeoutMinutes)
        }
      } catch (error) {
        console.error('Failed to fetch timeout setting:', error);
      }
    };

    fetchTimeoutSetting();
  }, [inputValue]);

  return (

    <div>
      {inputValue && inputValue !== null && <AutoLogout inputValue={inputValue} />}
      <Routes>
        <Route element={<SidebarLayout menuShowHide={menuShowHide} setMenuShowHide={setMenuShowHide} customerPermission={customerPermission} profileImage={profileImage} customData={customData} notesLength={notesLength} setRtl={setRtl} rtl={rtl} />}>
          <Route exact path="/" element={
            token ? token.access ? last_login !== null ?
              <Protecte><Dashboard customerPermission={customerPermission} /></Protecte> :
              <Navigate to="/changepwd" /> :
              <Navigate to="/login" /> :
              <Navigate to="/login" />} />
          <Route exact path='/check' element={token ? token.access ? last_login !== null ? <Checkmt /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/pendingcontract' element={token ? token.access ? last_login !== null ?
            <PendingContracts customerPermission={customerPermission} /> :
            <Navigate to="/changepwd" /> :
            <Navigate to="/login" /> :
            <Navigate to="/login" />} />
          <Route exact path='/invoicesdue' element={token ? token.access ? last_login !== null ?
            <InvoicesDue customerPermission={customerPermission} />
            : <Navigate to="/changepwd" /> :
            <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/contractsdashboard' element={token ? token.access ? last_login !== null ?
            <Contractsdashboard customerPermission={customerPermission} /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/unappliedpayments' element={token ? token.access ? last_login !== null ?
            <UnappliedPayments customerPermission={customerPermission} /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/testing" element={token ? token.access ? last_login !== null ? <TestTable /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Party  */}

          <Route exact path="/party" element={token ? token.access ? last_login !== null ?
            <Protecte><Party customerPermission={customerPermission} /></Protecte> :
            <Navigate to="/changepwd" /> :
            <Navigate to="/login" /> :
            <Navigate to="/login" />} />
          <Route exact path="/Addnewparty" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><AddnewPartyIndex customerPermission={customerPermission} /></Protecte> :
            <Navigate to="/" /> :
            <Navigate to="/changepwd" /> :
            <Navigate to="/login" />
            : <Navigate to="/login" />} />
          <Route exact path="/editparty" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><EditParty customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte> :
            <Navigate to="/" /> :
            <Navigate to="/changepwd" /> :
            <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/add" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><PartyAdd customerPermission={customerPermission} /></Protecte> :
            <Navigate to="/" /> :
            <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/details" element={token ? token.access ? last_login !== null ?
            <Protecte><PartyDetails customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte>
            : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/edit" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><PartyEdit customerPermission={customerPermission} /></Protecte> :
            <Navigate to="/" /> :
            <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />


          {/* address */}
          <Route exact path="/party/addAddress" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><PartyAddAddress customerPermission={customerPermission} /></Protecte> :
            <Navigate to="/" /> :
            <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/editAddress" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><EditAddress customerPermission={customerPermission} /></Protecte> :
            <Navigate to="/" />
            : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* contact */}
          <Route exact path="/party/contact" element={token ? token.access ? last_login !== null ?
            <Protecte><Partycontact customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/editContact" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><ContactEdit customerPermission={customerPermission} /></Protecte>
            : <Navigate to="/" /> :
            <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />


          {/* notification */}
          <Route exact path="/party/manageNotification" element={token ? token.access ? last_login !== null ? <Protecte><ManageNotification /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/viewNotification" element={token ? token.access ? last_login !== null ? <Protecte><ViewNotification /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/addNotification" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><AddNotification /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/party/editNotification" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><EditNotification /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Contarct */}
          <Route exact path="/addcontract" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><AddContract customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/create-lease" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><ContractLeaseForm customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/create-loan" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><CreateLoan customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/create-rental" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><CreateRental customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/createloancontract" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><CreateContractLoan customerPermission={customerPermission} /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/createrentalcontract" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><CreateRentalContract customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/editloancontract" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><EditLoanScreen customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/editrentalcontract" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ?
            <Protecte><ContractRentalEdit customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte>
            : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract" element={token ? token.access ? last_login !== null ? <Protecte><Contract customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/edit" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><ContractEdit customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/view" element={token ? token.access ? last_login !== null ? <Protecte><ContractView customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/create" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><CreateContract customerPermission={customerPermission} /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />


          {/* Amort */}
          <Route exact path="/contract/viewamortschedules" element={token ? token.access ? last_login !== null ? <Protecte><ViewAmortSchedules /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Payment Schedule */}
          <Route exact path="/contract/addPaymentSchedule" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><AddPaymentSchedules /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/editPaymentSchedule" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><EditPaymentSchedules /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Asset */}
          <Route exact path="/contract/assetsforloan" element={token ? token.access ? last_login !== null ? <Protecte><AsstesForLoan /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/addAsset" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><AddAssets /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/editAsset" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><EditAssets /></Protecte>
              : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/viewAsset" element={token ? token.access ? last_login !== null ? <Protecte><ViewAssets customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/contract/AssetRetrun" element={token ? token.access ? last_login !== null ? <Protecte><Assetsretrunscrren /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Quotes  */}
          <Route exact path="/createquote" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><QuoteAdd customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/viewquote" element={token ? token.access ? last_login !== null ? <Protecte><QuoteView customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Biilling */}
          <Route exact path="/billing" element={token ? token.access ? last_login !== null ? <Protecte><Billing customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/billing/editinvoices" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><EditInvoices customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/billing/createinvoices" element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><CreateInvoices customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/billing/temp" element={token ? token.access ? last_login !== null ? <Protecte><CreateInvoices1 customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/billing/viewinvoices" element={token ? token.access ? last_login !== null ? <Protecte><ViewInvoices customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Recipts */}
          <Route exact path="/receipts" element={token ? token.access ? last_login !== null ? <Protecte><ViewRecipts customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/receipts/createreceipts" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><CreateRecipts customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/receipts/editreceipts" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><EditRecipts customerPermission={customerPermission} setCustomData={setCustomData} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/receipts/viewreceipts" element={token ? token.access ? last_login !== null ? <Protecte><ShowRecipts customerPermission={customerPermission} setNotesLength={setNotesLength} setCustomData={setCustomData} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Reports */}
          <Route exact path="/reports" element={token ? token.access ? last_login !== null ? <Protecte><Reports /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/reports/contractreport" element={token ? token.access ? last_login !== null ? <Protecte><ContractReport customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/reports/invoicereport" element={token ? token.access ? last_login !== null ? <Protecte><InvoiceReport customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/reports/reciptreport" element={token ? token.access ? last_login !== null ? <Protecte><ReciptReport customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/manualaccountingreport" element={token ? token.access ? last_login !== null ? <Protecte><ManualAccountingReport customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />  
          <Route exact path="/expensereport" element={token ? token.access ? last_login !== null ? <Protecte><AllExpenseReport customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />


          {/* Processing */}
          <Route exact path='/processing' element={token ? token.access ? last_login !== null ? <Protecte><ViewProcessing customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/processing/genratebills' element={token ? token.access ? last_login !== null ? <Protecte><GenrateBills customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/processing/genratenotification' element={token ? token.access ? last_login !== null ? <Protecte><GenrateNotification customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Users */}
          <Route exact path="/user" element={token ? token.access ? last_login !== null ? <Protecte><ManageUser customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/user/adduser" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><AddUser customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/user/edituser" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><EditUser customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          {/* <Route exact path="/user/editcustomeruser" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><EditCustomerUser customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} /> */}
          <Route exact path="/user/editcustomeruser" element={token ? token.access ? last_login !== null ? <Protecte><EditCustomerUser customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> } />
          <Route exact path="/user/permissions" element={token ? token.access ? last_login !== null ? <Protecte><UserPermissionsTable customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Compnay Profile */}
          {/* <Route exact path="/profile" element={token ? token.access ? last_login !== null ? <Protecte><Profile setProfileImage={setProfileImage} profileImage={profileImage} customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} /> */}
          <Route exact path="/profile" element={token ? token.access ? last_login !== null ? <Protecte><CompanyProfile setProfileImage={setProfileImage} customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/companies" element={token ? token.access ? last_login !== null ? <Protecte><SubCompanies /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/lines-of-business" element={token ? token.access ? last_login !== null ? <Protecte><LinesOfBusiness /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/additionalsettings" element={token ? token.access ? last_login !== null ? <Protecte><Additionalsetting setProfileImage={setProfileImage} profileImage={profileImage} setTimeout={setTimeout} setInputValue={setInputValue} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/profile/editprofile" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><EditProfile /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Import */}
          <Route exact path="/import" element={token ? token.access ? last_login !== null ? <Protecte><Import /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* ItemMaster */}
          <Route exact path="/itemmaster" element={token ? token.access ? last_login !== null ? <Protecte><ItemMaster customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/itemmasteradd" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><Itemmasteradd customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/itemmasteredit" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><ItemmasterEdit customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/itemmasterview" element={token ? token.access ? last_login !== null ? <Protecte><ItemmasterView customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/addratecardheader" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><CreateRateCardHeader customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/editratecardheader" element={token ? token.access ? last_login !== null ? customerPermission !== 'Customer' ? <Protecte><EditRateCardHeader customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/ratecardheaderview" element={token ? token.access ? last_login !== null ? <Protecte><ViewRateCard customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/ratecard" element={token ? token.access ? last_login !== null ? <Protecte><RatecardTable customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Setting */}
          <Route exact path="/setting" element={token ? token.access ? last_login !== null ? <Protecte><Setting customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path="/editsetting" element={token ? token.access ? last_login !== null ? <Protecte><EditSetting customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route path="/party-roles" element={token ? token.access ? last_login !== null ? <Protecte><PartyRoleSettings /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route path="/term-condition" element={token ? token.access ? last_login !== null ? <Protecte><TermsConditions /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Additonal filed */}
          <Route exact path='/AdditionalFiled' element={token ? token.access ? last_login !== null ? <Protecte><EditExtrafileds customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Payment Screen */}
          {/* <Route exact path='/payment' element={token ? token.access ? last_login !== null ? <Protecte><PaymentScreen customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} /> */}
          <Route exact path='/payment' element={token ? token.access ? last_login !== null ? <Protecte><NewPaymentScreen customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/success' element={token ? token.access ? last_login !== null ? <Protecte><PaymentSuccess customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/invoicepaymnet' element={token ? token.access ? last_login !== null ? <Protecte><PaymentHandleScreen customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/paymentstripe' element={token ? token.access ? last_login !== null ? <Protecte><StripeConnectButton customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Accounting */}
          <Route exact path='/accountingperiods' element={token ? token.access ? last_login !== null ? <Protecte><AccountingPeriods customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/taxrateview' element={token ? token.access ? last_login !== null ? <Protecte><TaxRates customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/legalentities' element={token ? token.access ? last_login !== null ? <Protecte><LeagalEntities customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/accounts' element={token ? token.access ? last_login !== null ? <Protecte><Accounts customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/accountingsetup' element={token ? token.access ? last_login !== null ? <Protecte><AccountingSetup customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/trialbalance' element={token ? token.access ? last_login !== null ? <Protecte><TrialBalance customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/transactiontypes' element={token ? token.access ? last_login !== null ? <Protecte><TransactionTypes customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/transaction' element={token ? token.access ? last_login !== null ? <Protecte><Transaction customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/addaccountingsetup' element={token ? token.access ? last_login !== null ? <Protecte><AddAccountingSetup customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/chatbot' element={token ? token.access ? last_login !== null ? <Protecte><Testchatbot customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/addtaxrates' element={token ? token.access ? last_login !== null ? <Protecte><AddTaxRate customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/edittaxrates' element={token ? token.access ? last_login !== null ? <Protecte><EditTaxRate customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/taxrate' element={token ? token.access ? last_login !== null ? <Protecte><TaxRateView customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/schedule' element={token ? token.access ? last_login !== null ? <Protecte><FinalUnifiedScheduler customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/categories' element={token ? token.access ? last_login !== null ? <Protecte><Categories customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/addcategories' element={token ? token.access ? last_login !== null ? <Protecte><Createcategoriies customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/editcategories' element={token ? token.access ? last_login !== null ? <Protecte><Editcategory customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/viewcategories' element={token ? token.access ? last_login !== null ? <Protecte><Categoryview customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/achproviders' element={token ? token.access ? last_login !== null ? <Protecte><AchProviders customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/addachprovider' element={token ? token.access ? last_login !== null ? <Protecte><AddAchProvider customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/editachprovider' element={token ? token.access ? last_login !== null ? <Protecte><EditAchProvider customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/viewachprovider' element={token ? token.access ? last_login !== null ? <Protecte><ViewAchProvider customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          <Route exact path='/achfileview' element={token ? token.access ? last_login !== null ? <Protecte><ACHFileView customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/achaccounts' element={token ? token.access ? last_login !== null ? <Protecte><AchIndex customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/addachaccounts' element={token ? token.access ? last_login !== null ? <Protecte><AddAchAccounts customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/editachaccounts' element={token ? token.access ? last_login !== null ? <Protecte><EditAchAccounts customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/viewachaccounts' element={token ? token.access ? last_login !== null ? <Protecte><ViewAchAccount customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/settings' element={token ? token.access ? last_login !== null ? <Protecte><TileSettings customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/addaccounts' element={token ? token.access ? last_login !== null ? <Protecte><AddAccount customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/editaccounts' element={token ? token.access ? last_login !== null ? <Protecte><EditAccount customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />


          {/* Ticketing - WITH PERMISSION CHECKS - SHARED TICKET PROVIDER */}
          <Route path='/companyticket' element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><CompanyTickets customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to='/changepwd' /> : <Navigate to='/login' /> : <Navigate to='/login' />} />
          {/* <Route path='/internalticket' element={token ? token.access ? last_login !== null ? 
              customerPermission !== 'Customer' ? <Protecte><InternalTickets customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to='/changepwd' /> : <Navigate to='/login' /> : <Navigate to='/login' />} /> */}

          <Route path='/editcompanyticket' element={token ? token.access ? last_login !== null ?
            customerPermission !== 'Customer' ? <Protecte><EditCompanyTicket customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route path='/customerticket' element={token ? token.access ? last_login !== null ?
            customerPermission === 'Customer' ? <Protecte><UserTickets customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route path='/userticket' element={token ? token.access ? last_login !== null ?
            customerPermission === 'Customer' ? <Protecte><ViewUserTicket customerPermission={customerPermission} /></Protecte> : <Navigate to="/" /> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />


          {/* Json Upload */}
          <Route exact path='/json' element={token ? token.access ? last_login !== null ? <Protecte><JsonToDbImport customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Email Formator */}
          <Route exact path='/emailformat' element={token ? token.access ? last_login !== null ? <Protecte><EmailFormatter customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/emailtemplets' element={token ? token.access ? last_login !== null ? <Protecte><EmailTemplates customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/view-emailtemplets' element={token ? token.access ? last_login !== null ? <Protecte><EmailTemplatesView customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          

          {/* Documentation */}
          <Route exact path='/user-guide' element={token ? token.access ? last_login !== null ? <Protecte><Documentation customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/api-guide' element={token ? token.access ? last_login !== null ? <Protecte><ApiDocumentation customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          {/* Expenses */}
          <Route exact path='/expenses' element={token ? token.access ? last_login !== null ? <Protecte><Expenses customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/expenses/add' element={token ? token.access ? last_login !== null ? <Protecte><AddExpense customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/expenses/edit/:id' element={token ? token.access ? last_login !== null ? <Protecte><EditExpense customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/expenses/view/' element={token ? token.access ? last_login !== null ? <Protecte><ViewExpense customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

          <Route exact path='/expense-categories' element={token ? token.access ? last_login !== null ? <Protecte><ExpenseCategories customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/expense-categories/add' element={token ? token.access ? last_login !== null ? <Protecte><AddExpenseCategory customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/expense-categories/edit/:id' element={token ? token.access ? last_login !== null ? <Protecte><EditExpenseCategory customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          
          {/* report templates */}
          <Route exact path='/balancesheet' element={token ? token.access ? last_login !== null ? <Protecte><BalanceSheet customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/incomestatement' element={token ? token.access ? last_login !== null ? <Protecte><IncomeStatement customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/contractincome' element={token ? token.access ? last_login !== null ? <Protecte><ContractsIncome customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/contractbalances' element={token ? token.access ? last_login !== null ? <Protecte><ContractBalances customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/detailincomestatement' element={token ? token.access ? last_login !== null ? <Protecte><DetailIncomeStatement customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/detailbalancesheet' element={token ? token.access ? last_login !== null ? <Protecte><DetailBalanceSheet customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />



           {/* Manual Accounting */}
            <Route exact path='/manualaccounting' element={token ? token.access ? last_login !== null ? <Protecte><ManualAccountingIndex customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
            <Route exact path='/addmanualaccounting' element={token ? token.access ? last_login !== null ? <Protecte><AddManualAccount customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
            <Route exact path='/editmanualaccounting' element={token ? token.access ? last_login !== null ? <Protecte><EditManualAccount customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
            <Route exact path='/viewmanualaccounting' element={token ? token.access ? last_login !== null ? <Protecte><ViewManualAccounting customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
            
            {/* Transaction (merge of Expenses and Manual Accounting) */}
            <Route exact path='/transactions' element={token ? token.access ? last_login !== null ? <Protecte><Transactions customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

            {/* Approvals */}
            <Route exact path='/approvals' element={token ? token.access ? last_login !== null ? <Protecte><Approvals customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
            <Route exact path='/all-approvals' element={token ? token.access ? last_login !== null ? <Protecte><AllApprovals customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
            <Route exact path='/approvals/view' element={token ? token.access ? last_login !== null ? <Protecte><ViewRequest customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
            <Route exact path='/approvals/add' element={token ? token.access ? last_login !== null ? <Protecte><AddRequest customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />

           
          {/* <Route exact path='/document' element={token ? token.access ? last_login !== null ? <Protecte><Document customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} /> */}
          <Route exact path='/doc' element={token ? token.access ? last_login !== null ? <Protecte><Doc customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          {/* <Route exact path='/chatbotui' element={token ? token.access ? last_login !== null ? <Protecte><Chatboatui/></Protecte> : <Navigate to="/changepwd" />  : <Navigate to="/login"/>: <Navigate to="/login" />} /> */}

          <Route exact path="/supportticket" element={token ? token.access ? last_login !== null ? <Protecte><SupportTicket customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          {/* Search */}
          <Route exact path="/globalsearch" element={token ? token.access ? last_login !== null ? <Protecte><Searchshow customerPermission={customerPermission} /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/paymentconfirmsuccess' element={<PaymentConfirmExistingEle />} />
          <Route exact path='/changepwd' element={<Changepassword />} />

          {/* contract agent */}
          <Route exact path='/createcontractagent' element={token ? token.access ? last_login !== null ? <Protecte><CreateContractAgent  /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
          <Route exact path='/contractimport' element={token ? token.access ? last_login !== null ? <Protecte><ContractImportPage  /></Protecte> : <Navigate to="/changepwd" /> : <Navigate to="/login" /> : <Navigate to="/login" />} />
        
        </Route>


        {/* <SessionTimeout/> */}

        {/* <Route exact path="/login" element={<Login />} */}
        {/* /> */}
        {/* change password */}
        <Route exact path="/forgotpassword" element={<Forgotpassword />} />

        {/*impersonate  */}
        <Route exact path='/impersonate' element={<Impersonate setRtl={setRtl} />} />

        {/* <Route
          exact path="/sign-up"
          element={isLoggedIn ? <Navigate to="/payment" /> : <Register />}
        /> */}
        {/* <Route
          exact path="/register"
          element={isLoggedIn ? <Navigate to="/payment" /> : <SignUpSubscription />}
        /> */}
        <Route
          exact path="/register"
          element={isLoggedIn ? <Navigate to="/payment" /> : <NewSignup />}
        />
        {/*<Route
          exact path="/signup-delay"
          element={isLoggedIn ? <Navigate to="/payment" /> : <Signup />}
        />
          */}
        <Route
          exact path="/signup"
          element={isLoggedIn ? <Navigate to="/payment" /> : <SignUp />}
        />
        <Route
          exact path="/otpverification"
          element={isLoggedIn ? <Navigate to="/payment" /> : <Otp />}
        />
        <Route
          exact path="/login"
          element={isLoggedIn ? <Navigate to="/" /> : <Login setInputValue={setInputValue} setRtl={setRtl} />}
        />
        <Route exact path='/confirm' element={<ConfirmEle />} />
        <Route exact path='/confirmsubscription' element={<ConfirmSub />} />
        <Route exact path='/chatbotui' element={<Chatboatui />} />
        <Route exact path='/confirmexisting' element={<ConfirmEleExisting />} />
        <Route exact path='/confirmregister' element={<SingupConfirm />} />
        <Route exact path='/subscriptionsuccess' element={<SubscriptionSuccess />} />

        <Route exact path='/changepassword' element={<UserVerification />} />
      </Routes>
    </div>
  );
}

export default App;
